module.exports = __webpack_public_path__ + "img/28.f3e5b162.jpg";